var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tls-navbar",
      class: {
        "margin-bottom54":
          (_vm._.get(_vm.navbarContent, "menu") && _vm.hasIssuer()) ||
          (_vm.hasIssuer() &&
            (_vm._.get(_vm.applicationCenterCmsData, "open_login") ||
              _vm._.get(_vm.applicationCenterCmsData, "open_register")))
      },
      attrs: { id: "tls-navbar" }
    },
    [
      _c("div", { staticClass: "tls-navbar--content" }, [
        _c(
          "div",
          {
            staticClass: "tls-navbar--logo",
            on: { click: _vm.onMainLogoClick }
          },
          [
            _c("a", { staticClass: "tls-logo" }, [
              _c("img", {
                directives: [
                  {
                    name: "img-fallback",
                    rawName: "v-img-fallback",
                    value: _vm.imgFallback,
                    expression: "imgFallback"
                  }
                ],
                staticClass: "tls-logo--img",
                attrs: { src: _vm.logoStyle, alt: "tls-logo" }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tls-navbar--links",
            class: {
              "-opened": _vm.hamburgerOpen,
              "-closed": !_vm.hamburgerOpen,
              height52:
                (_vm._.get(_vm.navbarContent, "menu") && _vm.hasIssuer()) ||
                (_vm.hasIssuer() &&
                  (_vm._.get(_vm.applicationCenterCmsData, "open_login") ||
                    _vm._.get(_vm.applicationCenterCmsData, "open_register")))
            }
          },
          [
            _vm._l(_vm._.get(_vm.navbarContent, "menu"), function(
              menuItem,
              index
            ) {
              return _vm.navbarContent
                ? _c("div", { staticClass: "tls-navbar--slot" }, [
                    menuItem.items && menuItem.items.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "tls-dropdown",
                            on: {
                              click: function($event) {
                                return _vm.toggleDropdown(index)
                              }
                            }
                          },
                          [
                            _c("a", { staticClass: "tls-link-dropdown" }, [
                              _c(
                                "div",
                                { staticClass: "tls-link-dropdown--text" },
                                [_vm._v(_vm._s(menuItem.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "tls-link-dropdown--icon" },
                                [
                                  !_vm.dropdownStates[index]
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "chevron-down" }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.dropdownStates[index]
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "chevron-up" }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "tls-dropdown--content tls-dropdown--contents",
                                class: _vm.dropdownStates[index] ? "" : "hidden"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tls-dropdown-list" },
                                  _vm._l(menuItem.items, function(subMenuItem) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "tls-dropdown-list--slot",
                                        on: {
                                          click: function($event) {
                                            _vm.goToLink(
                                              _vm._.get(subMenuItem, "link", "")
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "tls-dropdown-text tls-dropdown-texts"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._.get(
                                                  subMenuItem,
                                                  "title",
                                                  ""
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.goToLink(_vm._.get(menuItem, "link", ""))
                              }
                            }
                          },
                          [
                            _c("a", { staticClass: "tls-link" }, [
                              _vm._v(_vm._s(_vm._.get(menuItem, "title", "")))
                            ])
                          ]
                        )
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _c("div", { staticClass: "tls-log" }, [
              _vm.hasIssuer() &&
              !_vm.authenticated &&
              _vm._.get(_vm.applicationCenterCmsData, "open_login")
                ? _c(
                    "div",
                    {
                      staticClass: "tls-navbar--slot tls-navbar-right",
                      on: {
                        click: function($event) {
                          return _vm.openLogin()
                        }
                      }
                    },
                    [
                      _c("a", { staticClass: "tls-button-link" }, [
                        _vm._v(
                          _vm._s(
                            _vm._.get(_vm.loginContent, "navbar_login_button")
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasIssuer() &&
              !_vm.authenticated &&
              _vm._.get(_vm.applicationCenterCmsData, "open_register")
                ? _c(
                    "div",
                    {
                      staticClass: "tls-navbar--slot",
                      on: {
                        click: function($event) {
                          return _vm.openRegister()
                        }
                      }
                    },
                    [
                      _c("a", { staticClass: "tls-button-link" }, [
                        _vm._v(
                          _vm._s(
                            _vm._.get(
                              _vm.loginContent,
                              "navbar_register_button"
                            )
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasIssuer() && _vm.authenticated
                ? _c("div", { staticClass: "tls-navbar--slot" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "tls-button-link tls-navbar-slot--myapplication",
                        on: {
                          click: function($event) {
                            return _vm.openMyApplication()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._.get(_vm.loginContent, "my_application_button")
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tls-navbar--slot",
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [
                        _c("a", { staticClass: "tls-link-uppercase" }, [
                          _vm._v(
                            _vm._s(_vm._.get(_vm.loginContent, "logout_button"))
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tls-navbar--slot",
            on: {
              mouseenter: function($event) {
                _vm.dropdownStates["language"] = true
              },
              mouseleave: function($event) {
                _vm.dropdownStates["language"] = false
              }
            }
          },
          [
            _c("div", { staticClass: "tls-dropdown" }, [
              _c("a", { staticClass: "tls-link-dropdown" }, [
                _vm._.get(_vm.selectedLanguage, "flag.data.url")
                  ? _c("img", {
                      staticClass: "tls-link-dropdown--flag",
                      attrs: {
                        alt: "language icon",
                        src: _vm._.get(_vm.selectedLanguage, "flag.data.url")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "tls-link-dropdown--text" }, [
                  _vm._v(_vm._s(_vm._.get(_vm.selectedLanguage, "name")))
                ]),
                _vm._v(" "),
                _vm.languages.length > 1
                  ? _c(
                      "div",
                      { staticClass: "tls-link-dropdown--icon" },
                      [
                        !_vm.dropdownStates["language"]
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "chevron-down" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dropdownStates["language"]
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "chevron-up" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.languages.length > 1
                ? _c(
                    "div",
                    {
                      staticClass: "tls-dropdown--content",
                      class: _vm.dropdownStates["language"] ? "" : "hidden"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tls-dropdown-list tls-dropdown-mobile"
                        },
                        _vm._l(_vm.languages, function(language) {
                          return language.code !== _vm.selectedLanguage.code
                            ? _c(
                                "div",
                                {
                                  key: language.code,
                                  staticClass: "tls-dropdown-list--slot",
                                  on: {
                                    click: function($event) {
                                      return _vm.changeLanguage(language.code)
                                    }
                                  }
                                },
                                [
                                  _vm._.get(language, "flag") === null
                                    ? _c("div", {
                                        staticClass: "tls-language-icon-null"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._.get(language, "flag") !== null
                                    ? _c("img", {
                                        staticClass:
                                          "tls-dropdown-list-slot--icon",
                                        attrs: {
                                          alt: "language icon",
                                          src: _vm._.get(
                                            language,
                                            "flag.data.url"
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    { staticClass: "tls-dropdown-text" },
                                    [_vm._v(_vm._s(language.name))]
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _vm.navbarContent
          ? _c(
              "div",
              {
                staticClass: "tls-navbar--hamburger",
                on: {
                  click: function($event) {
                    _vm.hamburgerOpen = !_vm.hamburgerOpen
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tls-hamburger",
                    class: _vm.hamburgerOpen ? "-state-opened" : "-state-closed"
                  },
                  [
                    _c("div", { staticClass: "tls-hamburger--top-line" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "tls-hamburger--middle-line" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "tls-hamburger--bottom-line" })
                  ]
                )
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }